import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

export const fetchTaskList = ({
  workspaceId, orchSha, runLimit = 30,
}) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      workspace_id: workspaceId,
      orch_sha: orchSha,
      run_limit: runLimit
    })
  };

  return postToApi('v1/api/task/list', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrTaskListFetcher = (queryParams) => {
  const [orchSha, workspaceId, runLimit] = queryParams;

  return fetchTaskList({
    orchSha, workspaceId, runLimit
  }).then(response => response.json());
}
export default fetchTaskList;
